import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import styles from './style.module.sass'

export default () => {
  const [visible, setVisible] = useState(false)
  const [eligible, setEligible] = useState(false)
  const [firstName, setFirstName] = useState(false)

  useEffect(() => {
    const getParams = queryString.parse(window.location.search)
    if (getParams.ref) {
      fetch(`https://app.maximustribe.com/api/referral_codes/eligible?referral_code=${getParams.ref}`)
      .then(async response => {
        if (!response.ok) return
        const data = await response.json()
        setFirstName(data.referrer_first_name)
        setEligible(data.eligible)
        setVisible(true)
        document.querySelector('html').classList.add('no-scroll')
        document.body.classList.add('no-scroll')
      })
    }
  }, [])

  const closeModalHandler = () => {
    document.querySelector('html').classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')
    setVisible(false)
  }

  return (
    <>
      {visible && (
        <div className={styles.referralModal}>
          <div className={styles.referralModalBg} onClick={closeModalHandler} />
          <div className={styles.referralModalWrap}>
            <div className={styles.referralModalBox}>
              <div className={styles.referralModalClose} onClick={closeModalHandler} />
              {eligible ? (
                <>
                  <p className={styles.referralModalTitle}>{firstName} gave you $50 off your first Maximus protocol.</p>
                  <p className={styles.referralModalText}>Not valid on weight loss protocols or lab tests.</p>
                </>
              ) : (
                <>
                  <p className={styles.referralModalTitle}>This referral is not valid any longer.</p>
                  <p className={styles.referralModalText}>{firstName} has reached the referral usage limit and that you will not receive a referral bonus.</p>
                </>
              )}
              <p className={styles.referralModalDone} onClick={closeModalHandler}>Done</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
